import { connect } from 'react-redux';
import Metrics from './Metrics';
import { getTelemetry } from '../../actions/telemetry';
import { getData } from '../../actions/utils';
import machinesSchema from '../../normalizr-schemas/machinesSchema';

const mapStateToProps = ({ machines, telemetry }) => ({
  machines,
  telemetry,
});

const mapDispatchToProps = dispatch => ({
  getOrganisationMachines: () => dispatch(getData('machines', 'machines', machinesSchema, false)),
  getTelemetry: (time, machines) => dispatch(getTelemetry(time, machines)),
});

const MetricsContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(Metrics);

export default MetricsContainer;



// WEBPACK FOOTER //
// ./src/components/Metrics/MetricsContainer.js